import { createUseStyles } from 'react-jss';

import { mediaQuery, ITheme } from '../../../styles';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    container: {
      width: 'min(100%, 1440px)',
      marginInline: 'auto',
    },
    upperContainer: {
      padding: [40, 40, 32, 40],

      [mediaQuery(breakpoints.mobile)]: {
        padding: [40, 24, 24],
      },
    },
    breadcrumbs: {
      margin: [12, 0, 40, 0],

      [mediaQuery(breakpoints.mobile)]: {
        marginBlockEnd: 24,
      },
    },
    tag: {
      marginBlockEnd: 12,
    },
    title: {
      fontSize: 60,
      color: '#000000',
      fontWeight: 500,
      lineHeight: '72px',
      marginBlockEnd: 8,

      [mediaQuery(breakpoints.mobile)]: {
        fontSize: 24,
        lineHeight: '32px',
      },
    },
    description: {
      color: 'var(--x-text-color-2)',
      fontSize: 20,
      fontWeight: 500,
      lineHeight: '28px',

      [mediaQuery(breakpoints.mobile)]: {
        fontSize: 14,
        lineHeight: '20px',
      },
    },
    rating: {
      paddingLeft: 28,
      paddingBottom: 12,
      marginTop: 0,
      justifyContent: 'left',

      [mediaQuery(breakpoints.mobile)]: {
        paddingLeft: 0,
        marginLeft: -12,
      },
    },
    tagRating: {
      display: 'flex',
      [mediaQuery(breakpoints.mobile)]: {
        display: 'initial',
      },
    },
    listClassName: {
      marginInline: 40,
      marginTop: 40,
      [mediaQuery(breakpoints.mobile)]: {
        alignItems: 'center',
      },
    },
    pillarClassName: {
      padding: [0, 0, 40, 0],
    },
    greyBg: {
      backgroundColor: 'var(--x-bg-5)',
    },
    cardsContainer: {
      display: 'grid',
      gap: 18,
      gridTemplateColumns: 'repeat(3, 1fr)',
      padding: [48, 40],

      [mediaQuery(breakpoints.laptop)]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },

      [mediaQuery(breakpoints.mobile)]: {
        padding: [48, 24],
        gridTemplateColumns: '1fr',
      },
    },
    otherTools: {
      margin: [80, 0, 0, 0],
      padding: [0, 24],

      [mediaQuery(breakpoints.mobile)]: {
        margin: [40, 0, 40, 0],
      },
    },
  }),
  { name: 'App' },
);
